const define = {
    "buttonText.discoverDefineClassic": "Discover Define® Classic",
    "buttonText.discoverDefineFresh": "Discover Define® Fresh",
    "buttonText.findStores": "Find Stores",
    "buttonText.learnMore": "Learn More",
    "buttonText.shopNow": "Shop Now",
    "buttonText.tryTheVirtualMirror": "Try the Virtual Mirror",
    "features.paragraph1.title": "Design with a purpose",
    "features.paragraph1.description": "Hand-drawn patterns of colour layers crafted with science to accentuate and not mask the natural beauty and hues of your eyes.",
    "features.paragraph2.title": "Breathability <span>^</span>",
    "features.paragraph2.description": "Our etafilcon A hydrogel material delivers 88% of available oxygen to the eye for long-lasting moisture and comfort.",
    "features.paragraph3.title": "Class 2 UV blocking <span>##</span>",
    "features.paragraph3.freshdescription": "Blocks ~82% of UVA and ~97% of UVB rays so you can enjoy protection in the sun.",
    "features.paragraph3.classicdescription": "Blocks ~82% of UVA and ~97% of UVB rays so you can enjoy protection in the sun.",
    "headline.classic.description": "Innovatively crafted <em>natural-toned hues </em>featuring limbal rings that <em>accentuate with bold&nbsp;charisma</em>",
    "headline.classic.title": "Define® Classic",
    "headline.fresh.description": "Scientifically designed to <em>enhance, brighten </em>and <em>lighten </em>with <em>playful nature-inspired colours</em>",
    "headline.fresh.title": "Define® Fresh",
    "lensWear.howToPut": "How to put in and remove your contact lenses.",
    "lensWear.insert1.description": "Wash hands with non-perfumed, anti-bacterial soap, and dry off with a lint-free towel.",
    "lensWear.insert1.title": "Start off clean",
    "lensWear.insert2.description": "Place lens on fingertip and hold it up to the light. If the edges flare out, it’s inside out—simply flip the lens.",
    "lensWear.insert2.title": "Check lens orientation",
    "lensWear.insert3.description": "Gently lift your upper and lower eyelid with one finger each to prevent blinking or eyelash obstruction.",
    "lensWear.insert3.title": "Lift lids for insertion",
    "lensWear.insert4.description": "While looking upward, move the lens toward your eye steadily. Slowly release your eyelid and close your eye to allow the lens to settle.",
    "lensWear.insert4.title": "Close eyelid to settle",
    "lensWear.insertion": "Insertion",
    "lensWear.removal": "Removal",
    "lensWear.remove1.description": "Ensure hands are clean and dry, then look up and carefully pull down your lower eyelid with your middle finger.",
    "lensWear.remove1.title": "Gently lower eyelid",
    "lensWear.remove2.description": "Bring your index finger to your eye slowly until you touch the lower edge of the lens, then slide the lens down to the lower white part of your eye.",
    "lensWear.remove2.title": "Slide and lower lens",
    "lensWear.remove3.description": "Gently pinch the lens with your thumb and index finger and remove it.",
    "lensWear.remove3.title": "Pinch to remove",
    "lensWear.remove4.description": "1-day ACUVUE® Define® contact lenses are daily disposable lenses, so discard them after removal.",
    "lensWear.remove4.title": "Discard",
    "lensWear.title": "Lens Wear",
    "related.discover": "Discover",
    "showNow.title": "Shop Now",
    "showNow.description": "Get exclusive deals on ACUVUE® brand products online now",
    "showNow.physical.details": "Find your nearest authorised ACUVUE® store:",
    "specs.additionalInfo": "Additional Information",
    "specs.baseCurve": "Base Curve",
    "specs.baseCurve.detail": "8.5mm",
    "specs.centre": "Centre Thickness",
    "specs.centre.fresh.detail": "14.2mm",
    "specs.centre.classic.detail": "14.2mm",
    "specs.internal": "Internal Wetting Agent",
    "specs.internal.detail": "Polyvinylpyrrolidone (PVP) using LACREON® Technology",
    "specs.material": "Material",
    "specs.material.detail": "Etafilcon A",
    "specs.oxygen": "Oxygen Transmissibility",
    "specs.oxygen.detail": "(Dk/t) (boundary & edge corrected) 25.5 x 10-9 (for -3.00D)",
    "specs.packageSize": "Package Size",
    "specs.packageSize.fresh.detail": "30 lenses/box",
    "specs.packageSize.classic.detail": "30 lenses/box",
    "specs.freshpowerRange": "Power Range",
    "specs.classicpowerRange": "Power Range",
    "specs.freshpowerRange.detail": "+1.00D to Plano (0.50D steps);<br /> -0.50D to -6.00D (0.25D steps);<br /> -6.50D to -9.00D (0.50D steps)",
    "specs.classicpowerRange.detail": "+1.00D to Plano (0.50D steps);<br /> -0.50D to -6.00D (0.25D steps);<br /> -6.50D to -9.00D (0.50D steps)",
    "specs.specifications": "Specifications",
    "specs.water": "Water Content",
    "specs.water.detail": "58%"
}

const download_now = {
  "download_now.title": "Enjoy $20 off your first purchase ",
  "download_now.p": "Join MyACUVUE® now to unlock all privileges!",
  "download_now.button": "Learn More",
}

const define_references = {
  "define_references_link": "https://www.acuvue.com.sg/patient-instruction-guide/",
}

Object.defineProperty(define_references, 'references.content', {
  get: function() {
    return `
    <h1>REFERENCES/ DISCLAIMER</h1>
    <p>^JJV Data on File 2021. Material Properties of 1-DAY ACUVUE DEFINE Brand Contact Lenses with LACREON – Core Variants and Fresh Collection Range Variants, including AFM and SEM Testing. NOTE: Oxygen is only one of several factors related to maintaining overall eye health when wearing contact lenses.</p>
    <p>## Helps protect against transmission of harmful UV radiation to the cornea and into the eye. Warning: UV-absorbing contact lenses are NOT substitutes for protective UV-absorbing eyewear such as UV-absorbing goggles or sunglasses because they do not completely cover the eye and surrounding area. You should continue to use UV-absorbing eyewear as directed. NOTE: Long-term exposure to UV radiation is one of the risk factors associated with cataracts. Exposure is based on a number of factors such as environmental conditions (altitude, geography, cloud cover) and personal factors (extent and nature of outdoor activities). UV-blocking contact lenses help provide protection against harmful UV radiation. However, clinical studies have not been done to demonstrate that wearing UV-blocking contact lenses reduces the risk of developing cataracts or other eye disorders. Consult your eye care practitioner for more information.</p>
    <h2>Important information for contact lens wearers </h2>
    <p>ACUVUE® Brand Contact Lenses are available by prescription only for vision correction. An eye care professional will determine whether contact lenses are right for you. Although rare, serious eye problems can develop while wearing contact lenses. To help avoid these problems, follow the wear and replacement schedule and the lens care instructions provided by your eye doctor. Do not wear contact lenses if you have an eye infection, or experience eye discomfort, excessive tearing, vision changes, redness or other eye problems. If one of these conditions occurs, contact your eye doctor immediately. For more information on proper wear, care and safety, talk to your Eye Care Professional or refer to ACUVUE®'s
    <a href="${this.define_references_link}">Patient Instruction Guide</a>.</p>`;
  },
  enumerable: true,
  configurable: true
});



export default {
  ...define,
  ...define_references,
  ...download_now,
};
